export default __webpack_public_path__ + "static/Mobile-optimization-72fceaa7c6c8dab5ecbcd27290987e5b.webp";